import { render, staticRenderFns } from "./glosa.vue?vue&type=template&id=53c8b912&scoped=true&"
import script from "./glosa.vue?vue&type=script&lang=ts&"
export * from "./glosa.vue?vue&type=script&lang=ts&"
import style0 from "./glosa.vue?vue&type=style&index=0&id=53c8b912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8b912",
  null
  
)

export default component.exports